<template>
  <div class="new-main-footer-revamp__item__child">
    <div class="new-main-footer-revamp__item__child__wrapper">
      <div class="new-main-footer-revamp__item__child__title">
        Informasi lain
      </div>
      <div
        v-if="other.length > 0"
        class="sitemap"
      >
        <router-link
          v-for="nav in other"
          :key="nav.title"
          name="spanServices"
          :to="nav.link"
        >
          {{ nav.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OtherInfoFooter",
  data() {
    return {
      other: [
        {
          title: "Dangerous Goods",
          link: "/dangerous-goods",
        },
        {
          title: "Karantina",
          link: "/karantina",
        },
        {
          title: "FAQ",
          link: "/faq",
        },
        {
          title: "Tentang kami",
          link: "/about",
        },
        // {
        //   title: "Berita",
        //   link: "#",
        // },
        {
          title: "Karir",
          link: "/career",
        },
      ],
    }
  },
  methods: {
    onClick(url) {
      if(url) {
        return this.$router.push(url)
      }
    }
  }
}
</script>
